import { render, staticRenderFns } from "./LocationDescription.vue?vue&type=template&id=450d6fb1&"
import script from "./LocationDescription.js?vue&type=script&lang=js&"
export * from "./LocationDescription.js?vue&type=script&lang=js&"
import style0 from "./LocationDescription.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports